
//Welcome screen to home transition
$(document).ready(function () {
  if (window.location.hash) {
    $('header.site-header').hide();
    $('nav').delay(1500).fadeIn(300);
    if (window.location.hash.substr(1).split("_")[0] !== 'your-report') {
      $('#secondary').delay(500).fadeIn(300);
    }

  } else {
    $('header.site-header').show();
    $('header.site-header').delay(1500).fadeOut(500);
    $('#home').delay(1500).fadeIn(300);
    $('#secondary').delay(1500).fadeIn(300);
    $('nav').delay(1500).fadeIn(300);
  }
});

setTimeout(function () {
  $('body').removeClass('no-scroll');
}, 500)

//Navigation between sections
$('nav ul li').on('click', 'a', function (e) {
  $('nav ul li').removeClass('active');
  $(this).parent().addClass('active');
  var currentSection = $(this).attr('href').slice(1);
  //$('.fullscreen-section').fadeOut(500);
  //$('#' + currentSection).fadeIn(500);
  $("html").animate({ scrollTop: 0 }, 200);
  
  if(!$(this).parent().hasClass('download-link')){
    location.hash = $(this).attr('href');  
    e.preventDefault();
  }

});


$('.nextpage').on('click', function (e) {
  var currentPage = $(this).attr('href').slice(1);

  $('nav ul li').removeClass('active');
  var currentMenu = $('nav ul li a[href="#' + currentPage + '"]');
  currentMenu.parent().addClass('active');
  // console.log(currentMenu);
  // $('.fullscreen-section').fadeOut(500);
  // $('#' + currentPage).fadeIn(500);
  location.hash = $(this).attr('href');
  e.preventDefault();
})


//chart 
function pieChart(stageValue, stageClass) {
  var game = { score: 0 },
    scoreDisplay = document.querySelector('.' + stageClass + '_score-1');
  var scoreValue = '+' + stageValue;
  var stokeValue = Math.floor(300 * stageValue / 100);
  var colorFOr = '';
  if (stageClass == 'report') {
    colorFOr = "_stage";
  }
  else if (stageClass == 'nextStep') {
    colorFOr = "_nextStep";
  }

  $('.' + stageClass + '_animate1').css("stroke-dasharray", "0 300");
  if (stageValue > 66) {
    $('.' + stageClass + '_animate1').css("stroke", "url(#linear-gradient85_report" + colorFOr + ")");
    $('#' + stageClass + '_Path_200').css("fill", "#A2D23F");
    $('#' + stageClass + '_pie_Path_200').css("fill", "#A2D23F");
  }
  else if (66 > stageValue && stageValue > 33) {
    $('.' + stageClass + '_animate1').css("stroke", "url(#linear-gradient66_report" + colorFOr + ")");
    $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_orange)");
    $('#' + stageClass + '_pie_Path_200').css("fill", "url(#" + stageClass + "_pie_info_orange)");
  }
  else {
    $('.' + stageClass + '_animate1').css("stroke", "url(#linear-gradient33_report" + colorFOr + ")");
    $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_pink)");
    $('#' + stageClass + '_pie_Path_200').css("fill", "url(#" + stageClass + "_pie_info_pink)");
  }

  function updateHandler() {
    scoreDisplay.innerHTML = game.score;
  }
  var c1Section3 = new TimelineLite();
  c1Section3.from('.' + stageClass + '_animate1', 3, { "stroke-dasharray": "0 300", ease: Expo.easeNone }, 0)
  c1Section3.to('.' + stageClass + '_animate1', 3, { "stroke-dasharray": stokeValue + " 300", ease: Expo.easeNone }, 0)
    .to(game, 3, {
      score: scoreValue,
      roundProps: "score",
      onUpdate: updateHandler,
      ease: Expo.easeNone
    }, 0);
}

$('.total-score-menu').on('click', function (e) {
  pieChart($('.progress_score-1').html(), 'progress');
  numCounter($('#progress_score-2').html(), 'progress');
});

$('.nextStep-menu').on('click', function (e) {
  pieChart($('.nextStep_score-1').html(), 'nextStep');
  numCounter($('#nextStep_score-2').html(), 'nextStep');
});

$('.nextpagecontact').on('click', function (e) {
  pieChart($('.nextStep_score-1').html(), 'nextStep');
  numCounter($('#nextStep_score-2').html(), 'nextStep');
});

function numCounter(stageValue, stageClass) {

  if (stageValue < 2) {
    $('#' + stageClass + '_Path_1114').css("fill", "#009245");
    $('#' + stageClass + '_color_dot path').css("fill", "#0072FE");
    $('#' + stageClass + '_Path_200').css("fill", "#A2D23F");
  }
  else if (4 > stageValue && stageValue > 1) {
    $('#' + stageClass + '_Path_1114').css("fill", "#F7931E");
    $('#' + stageClass + '_color_dot path').css("fill", "#FDC600");
    $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_orange)");
  }
  else {
    $('#' + stageClass + '_Path_1114').css("fill", "#9E005D");
    $('#' + stageClass + '_color_dot path').css("fill", "#FD4B00");
    $('#' + stageClass + '_Path_200').css("fill", "url(#" + stageClass + "_info_pink)");
  }

  var counter = 0;
  var maxValue = stageValue;
  var nc0 = '#' + stageClass + '_score-2';
  var nc1 = '#' + stageClass + '_score-2_swap';
  var n0 = document.querySelector(nc0);
  var n1 = document.querySelector(nc1);

  countDown();
  function countDown() {
    if (counter < maxValue) {
      counter++;
      n1.textContent = counter;
      TweenMax.to(nc0, 0.1, {
        y: "20-=70",
        delay: 0.1,
        ease: Power3.easeInOut,
        onComplete: swapNodes
      });
    }
  }

  function swapNodes() {
    n0.textContent = counter;
    TweenMax.set(nc0, { y: "20+=70", onComplete: countDown });
  }
}


//Report Button Click
var currentStageTitle = $('.current-stage-title'),
  currentStageScore = $('.current-stage-score'),
  currentStageScoreTt = $('.current-stage-score-tt'),
  currentStageCriticalFact = $('.current-stage-critical'),
  currentStageCriticalFactTt = $('.current-critical-factor-tt'),
  currentBlockContent = $('.current-block-content');

//Load Search Value in current Stage
var firstStage = $('.button-group button:first-child').text().toLowerCase();
currentStageTitle.html($("." + firstStage + '-title').html());
currentStageScore.html($("." + firstStage + '-score').html());
currentStageScoreTt.html($("." + firstStage + '-score-tooltip').html());
currentStageCriticalFact.html($("." + firstStage + '-critical').html());
currentStageCriticalFactTt.html($("." + firstStage + '-critical-tooltip').html());
currentBlockContent.html($("." + firstStage + '-block-content').html());
$('#prev-sec').hide();



$('.button-group').on('click', 'button', function (e) {

  let currentStage = $(this).text().toLowerCase();

  let href = window.location.href.split("_", 1);
  if (href.indexOf('_') !== -1) {
    newHref = href + '_' + 'queryString';
  } else {
    newHref = href + '_' + currentStage;
  }
  window.location.href = newHref;

  $('.button-group button').removeClass('active-stage');
  $(this).addClass('active-stage');

  if ($('.button-group button:last-child').hasClass('active-stage')) {
    $('.prevnext').fadeOut(50);
    $('.nextpagecontact').fadeIn(200).css('display', 'block');
  } else {
    $('.prevnext').fadeIn(50);
    $('.nextpagecontact').fadeOut(50).css('display', 'none');
  }


  if ($('.button-group button:first-child').hasClass('active-stage')) {
    $('#prev-sec').hide();
  } else {
    $('#prev-sec').show();
  }

  currentStageTitle.animate({ opacity: '0' }, 100);
  setTimeout(function () {
    currentStageTitle.html($("." + currentStage + '-title').html())
  }, 100);
  currentStageTitle.animate({ opacity: '1' }, 100);

  //currentStageTitle.html($("." + currentStage + '-title').html());
  currentStageScore.html($("." + currentStage + '-score').html());
  currentStageScoreTt.html($("." + currentStage + '-score-tooltip').html());
  currentStageCriticalFact.html($("." + currentStage + '-critical').html());
  currentStageCriticalFactTt.html($("." + currentStage + '-critical-tooltip').html());
  currentBlockContent.html($("." + currentStage + '-block-content').html());
  pieChart($("." + currentStage + '-score').html(), 'report');
  numCounter($("." + currentStage + '-critical').html(), 'report');

  var cf = currentStageCriticalFact.html();
  if(cf == 1){
    $('.cf').html('CRITICAL FACTOR');
  } else {
    $('.cf').html('CRITICAL FACTORS');
  }
})

$('.your-report-menu').on('click', function (e) {
  pieChart($("." + firstStage + '-score').html(), 'report');
  numCounter($("." + firstStage + '-critical').html(), 'report');
});

function nextSec() {
  $("html").animate({ scrollTop: 0 }, 200);
  $('.active-stage').next().trigger('click');

  if ($('.button-group button:last-child').hasClass('active-stage')) {
    $('.prevnext').fadeOut(50);
    $('.nextpagecontact').fadeIn(200).css('display', 'block');
  } else {
    $('.prevnext').fadeIn(50);
    $('.nextpagecontact').fadeOut(50).css('display', 'none');
  }

  if ($('.button-group button:first-child').hasClass('active-stage')) {
    $('#prev-sec').hide();
  } else {
    $('#prev-sec').show();
  }

}

function prevSec() {
  $("html").animate({ scrollTop: 0 }, 200);
  $('.active-stage').prev().trigger('click');


  if ($('.button-group button:last-child').hasClass('active-stage')) {
    $('.prevnext').fadeOut(50);
    $('.nextpagecontact').fadeIn(200).css('display', 'block');
  } else {
    $('.prevnext').fadeIn(50);
    $('.nextpagecontact').fadeOut(50).css('display', 'none');
  }

  if ($('.button-group button:first-child').hasClass('active-stage')) {
    $('#prev-sec').hide();
  } else {
    $('#prev-sec').show();
  }
}

$('.download-link').on('click', 'a', function (e) {
  //e.preventDefault()
})

// if ($(window).width() > 767) {
//   $(function () {
//     //moveScroller();
//   });

// }

// function moveScroller() {
//   var num = $(".button-group").offset().top;
//   var move = function () {

//     if ($(window).scrollTop() > num) {
//       $('.button-group').addClass('fixed');
//     }
//     else {
//       //num = $('.menuFlotante').offset().top;
//       $('.button-group').removeClass('fixed');
//     }

//   };
//   $(window).scroll(move);
//   move();
// }


if (window.location.hash) {

  // if window location contains hash
  var crnthash = window.location.hash.substr(1).split('_')[0];

  if (window.location.hash.indexOf('_') != -1) {
    var n = window.location.hash.split("_");
    var result = n[n.length - 1];
  }

  if (crnthash == 'your-report') {
    $('.button-group').hide();
    $('#secondary').hide();
  }

  $('.fullscreen-section').fadeOut(1);
  $('#' + crnthash).fadeIn(500);

  $("html").animate({ scrollTop: 0 }, 200);
  $('nav ul li').removeClass('active');
  $('a[href=#' + crnthash + ']').parent().addClass('active');

  setTimeout(function () {
    if (crnthash == 'total-score') {
      pieChart($('.progress_score-1').html(), 'progress');
      numCounter($('#progress_score-2').html(), 'progress');
    } else if (crnthash == 'your-report') {
      $('#secondary').hide();
      $('.button-group').fadeIn();

      if (window.location.hash.indexOf('_') != -1) {
        pieChart($("." + result + '-score').html(), 'report');
        numCounter($("." + result + '-critical').html(), 'report');
        $('#secondary').hide();
       
      } else {
        pieChart($("." + firstStage + '-score').html(), 'report');
        numCounter($("." + firstStage + '-critical').html(), 'report');
        $('#secondary').hide();
        
      }
    }
    else if (crnthash == 'contact') {
      pieChart($('.nextStep_score-1').html(), 'nextStep');
      numCounter($('#nextStep_score-2').html(), 'nextStep');
    }
  }, 2);

  if (result !== '') {
    $('#' + result).click();
  }

}

window.onhashchange = function () {
  var hashmain = window.location.hash;
  var hash = window.location.hash.substr(1).split("_", 1);

  if (window.location.hash.substr(1).split("_")[1] == null) {
    $('.fullscreen-section').fadeOut(500);
    $('#' + hash).fadeIn(500);
    $("html").animate({ scrollTop: 0 }, 200);
    $('nav ul li').removeClass('active');
    $('a[href=#' + hash + ']').parent().addClass('active');
  }

  if (window.location.hash.substr(1).split("_")[0] == 'your-report') {
    $('#secondary').hide();
    //console.log('Your Report Section');
  } else {
    $('#secondary').show();
    //console.log('Other Section');
  }

}

document.addEventListener("scroll", function() {
  const el = document.querySelector(".button-group");
  const ref = document.querySelector(".current-stage-title-cont");
  let rect = ref.getBoundingClientRect();
  if (rect.top <= 0) {
    el.classList.add("sticky-right");
  } else {
    el.classList.remove("sticky-right");
  }
});